/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Render_All_Fit_Prompt_TextInputs */



/**
* | output |
* | --- |
* | "Fit to Event duration adjusts each Event's Speed so the audio matches the Event's current timing." |
*
* @param {Render_All_Fit_Prompt_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const render_all_fit_prompt_text = /** @type {((inputs?: Render_All_Fit_Prompt_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Render_All_Fit_Prompt_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("« Ajuster à la durée » modifie la vitesse de chaque événement pour que l'audio corresponde à sa durée actuelle.")
	if (locale === "de") return /** @type {LocalizedString} */ ("„An Event-Dauer anpassen“ setzt das Tempo jedes Events so, dass das Audio zum aktuellen Timing passt.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Adatta alla durata regola la velocità di ogni evento perché l'audio corrisponda alla durata attuale.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("«Подогнать под длительность» меняет скорость воспроизведения каждого события, чтобы аудио совпало с текущим таймингом.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ajustar a la duración cambia la velocidad de cada evento para que el audio coincida con su duración actual.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("“适配事件时长”会调整每个事件的播放速度，使音频与事件当前的时长一致。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("「イベントの長さに合わせる」を選ぶと、各イベントの再生速度を調整し、音声を現在のタイミングに合わせます。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इवेंट अवधि में फिट करें हर इवेंट की गति बदलता है ताकि ऑडियो इवेंट की मौजूदा टाइमिंग से मेल खाए।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Ajustar à duração altera a velocidade de cada evento para que o áudio corresponda à duração atual.")
	return /** @type {LocalizedString} */ ("Fit to Event duration adjusts each Event's Speed so the audio matches the Event's current timing.")
});